import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core/services';
import { Qr } from '../models/qr.model';
import { GeneralResponse } from '@core/models';
import { Floor } from '../models';
@Injectable({
  providedIn: 'root',
})
export class QrService {
  private apiService = inject(ApiService);

  getQR(data: any): Observable<GeneralResponse<Qr[]>> {
    console.log(data, 'datos');
    if ('buildingid' in data && 'floorid' in data) {
      console.log(data, 'nivel');
      const floorData = data as Floor; // Realizamos un type assertion
      // Es un objeto Floor con floorid definido
      return this.apiService.post<Qr[]>(
        `qr?building=${data.buildingid}&floor=${floorData.floorid}`,
        {}
      );

      // Es un objeto Building
    } else {
      console.log(data, 'edificio');
      return this.apiService.post<Qr[]>(`qr?building=${data.buildingid}`, {});
    }
  }
}
